import axios from 'axios'
const instance = axios.create({
    baseURL: process.env.VUE_APP_MASTERS_API_URL
});
export default {
    getAudienceRoles: async function () {
        try {
            const response = await instance.get('/audienceRoles')
            return response;
        } catch (error) {
            return error.response;
        }
    },

}
 